"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _createStyles = require("../styles/createStyles");
const _excluded = ["classes", "className", "color", "orientation"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _createStyles.createStyles)(_ref => {
  let {
    theme
  } = _ref;
  return {
    root: {
      position: 'absolute',
      height: 2,
      bottom: 0,
      width: '100%',
      transition: theme.transitions.create('all')
    },
    colorPrimary: {
      backgroundColor: theme.busbud.colors.component.tab.border.primary
    },
    colorSecondary: {
      backgroundColor: theme.busbud.colors.component.tab.border.secondary
    },
    vertical: {
      height: '100%',
      width: 2,
      right: 0
    }
  };
});
const TabIndicator = /*#__PURE__*/React.forwardRef(function TabIndicator(props, ref) {
  const {
      classes: classesOverrides,
      className,
      color,
      orientation
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    classes,
    cx
  } = useStyles({
    classesOverrides
  });
  return /*#__PURE__*/React.createElement("span", (0, _extends2.default)({
    "data-testid": "tab-indicator",
    className: cx(classes.root, {
      [classes.vertical]: orientation === 'vertical',
      [classes.colorPrimary]: color === 'primary',
      [classes.colorSecondary]: color === 'secondary'
    }, className),
    ref: ref
  }, other));
});
var _default = exports.default = TabIndicator;